import { CustomizableValidator } from '../../types/Validator';

const errorCode = 'MAX_NUMBER';

interface MatchProps {
  max: number;
}

const maxNumber: CustomizableValidator<MatchProps> = ({
  max,
  variables
}) => value => {
  if (max && Number(value) > max) {
    return {
      errorCode,
      params: variables
    };
  }
};

export { maxNumber, errorCode };
